<template>
    <!-- <div>
        <form action="" @submit.prevent="search">
            <div action="" class="search ma-r-big">
                <input type="text" class="search__input" v-model="filter" placeholder="pesquisar">
                
            </div>
            
        </form>

    </div> -->

	<!-- COMPONENT OF SEARCH -->
	<div class="mt-3 flex flex-col sm:flex-row">
		<div class="flex">
			
		</div>

		<div class="block relative mt-3 sm:mt-0">
			<span class="absolute inset-y-0 left-0 flex items-center pl-2">
				<svg viewBox="0 0 24 24" class="h-4 w-4 fill-current text-gray-500">
					<path d="M10 4a6 6 0 100 12 6 6 0 000-12zm-8 6a8 8 0 1114.32 4.906l5.387 5.387a1 1 0 01-1.414 1.414l-5.387-5.387A8 8 0 012 10z"></path>
				</svg>
			</span>

			<input v-model="filter" placeholder="Pesquisar" class="appearance-none  rounded border border-gray-400 border-b block pl-8 pr-6 py-3 w-full bg-gray-100 text-sm placeholder-gray-500 text-gray-700 focus:bg-white focus:placeholder-gray-600 focus:text-gray-700 focus:outline-none" />
		</div>
	</div><!--/COMPONENT OF SEARCH -->
</template>
<script>
export default {
    data () {
        return {
            filter: ''
        }
    },

    methods: {
        search () {
            this.$emit('search', this.filter)
        }
    }
}
</script>

<style lang="">
    
</style>
